<fd-popover
    #cantAccessPathPopover
    [focusTrapped]="true"
    [focusAutoCapture]="true"
    [closeOnOutsideClick]="true"

>
    <fd-popover-control>
        <button
                fd-button
                id="cant-access-path-btn"
                label="Can't access a path?"
                i18n-label="XBUT|Can't access a path? button@@cantAccessPath.openButton"
                [fdMenu]="false"
                [fdCompact]="true"
                [fdType]="'transparent'"
                title="Can't access a path?"
                style="color: #007bff;"
                i18n-title="XTOL|Tooltip of the Can't access a path? button@@cantAccessPathTooltip"
        >
        </button>
    </fd-popover-control>

    <fd-popover-body class="cant-access-path">
        <div     class="cant-access-path-popover"
        >
            <div fd-popover-body-header>
                <div fd-bar id="popover-bar-header-cant-access-path">
                    <div fd-bar-left>
                        <fd-bar-element
                                class="header-title"
                                i18n-title="XTIT|Title of the Can't Access Path Popover@@cantAccessPath.popoverTitle"
                        >
                            Access to Paths
                        </fd-bar-element>
                    </div>
                </div>
            </div>

            <div class="wrapper">
                <div class="popover-content" style="padding: 16px; font-size: 14px; line-height: 1.5;">
                    <p>You may not have access to all listed paths to view the respective resources.</p>
                    <p>To obtain access, please contact the administrator of the related resource group.</p>
                    <p>
                        If the path is in the 'sap-internal' organization, go to the
                        <a
                                href="https://int.controlcenter.ondemand.com/index.html"
                                target="_blank"
                                style="color: #007bff;"
                        >SAP BTP control center</a
                        > <br>
                        in the relevant landscape. Then, select the associated global account in the
                        <br>
                        <strong>Global Account</strong> dropdown menu, and from the <strong>... (Actions)</strong>  context menu, select
                        <br>
                        <strong>Sync Global Account Admins.</strong>
                    </p>
                </div>
            </div>
        </div>
    </fd-popover-body>
</fd-popover>
